module.exports = __webpack_public_path__ + "img/objective2.1593ba78.jpg";